import { forwardRef } from "react";

import { cn } from "../lib/cn";

export type InputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "style"
> & {
  hasError?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { hasError, className, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      spellCheck={false}
      className={cn(
        "text-text w-full rounded-sm bg-[rgba(14,14,14,0.8)] px-4 py-3.5 font-mono text-xs tracking-[0.04em] outline-none transition-[border-color] duration-300",
        "border",
        hasError ? "border-[var(--color-error-border)]" : "border-gold-dim",
        "placeholder:text-text-muted",
        className,
      )}
      {...props}
    />
  );
});
